import React from "react";

// Gerekli ikonları import edelim
import { FaPhoneAlt, FaArrowRight, FaPaw } from "react-icons/fa";

// Stil dosyamızı import edelim
import "./TwoColumnSection.scss";

// Görseli import edelim (kendi görselinle değiştirebilirsin)
import sectionImage from "../../assets/images/vet-with-dog.png";
import greenCatIcon from "../../assets/images/green-cat.png";
import arrowIcon from "../../assets/images/green-right-arrow-icon.png";

// Madde listesi için veri dizisi
const features = [
  { text: "Yeni Nesil Veterinerlik Hizmetleri" },
  { text: "Güncel Tıbbi Donanım " },
  { text: "Teşhise Yönelik Tedavi" },
  { text: "Alanında Uzman Ekip" },
];

const TwoColumnSection = () => {
  return (
    <section className="two-column-section page-container">
      {/* Sol Sütun: Metin İçeriği */}
      <div className="text-column">
        <div className="section-subtitle">
          <img className="icon" src={greenCatIcon} alt="Green Cat Icon" />
          <span>Neler sunuyoruz?</span>
        </div>

        <h2 className="section-title">
          Patili dostlarınıza doğru şekilde nasıl yardımcı olabiliriz?
        </h2>

        <p className="section-description">
          Patili dostlarınızın sağlığı ve mutluluğu bizim önceliğimiz. Deneyimli
          ekibimiz ve sevgi dolu yaklaşımımızla, doğru teşhis ve tedavi
          yöntemleri sunuyoruz. Sağlık kontrollerinden acil müdahalelere kadar
          her adımda yanınızdayız.
        </p>

        <div className="features-grid">
          {features.map((feature, index) => (
            <div key={index} className="feature-item">
              {/* İkonu direkt olarak burada render ediyoruz */}
              <div className="feature-icon">
                <FaPaw />
              </div>
              <span className="feature-text">{feature.text}</span>
            </div>
          ))}
        </div>

        <div className="bottom-actions">
          <button className="discover-button">Daha Fazlasını Keşfedin</button>
          <div className="phone-callout">
            <div className="phone-icon-wrapper">
              <FaPhoneAlt />
            </div>
            <div className="phone-text-wrapper">
              <span className="call-us-text">Dilediğiniz Zaman Arayın</span>
              <span className="phone-number-text">+90 538 597 04 41</span>
            </div>
          </div>
        </div>
      </div>

      {/* Sağ Sütun: Görsel */}
      <div className="image-column">
        <img src={sectionImage} alt="Veteriner ve köpek" />
      </div>
    </section>
  );
};

export default TwoColumnSection;
